import { Component, EventEmitter, HostListener, Input, Output } from '@angular/core';
import { ToastService } from '@teorema/patron';
import { Ticket, TicketDocument } from 'src/app/models';
import { TcTicketService } from 'src/app/shared/services';

@Component({
  selector: 'app-ticket-documents',
  templateUrl: './ticket-documents.component.html',
  styles: [],
  standalone: false,
})
export class TicketDocumentsComponent {
  @Input() entity?: Ticket;

  @Output() saving = new EventEmitter<boolean>();
  @Output() save = new EventEmitter<any>();

  @Input() uploadPath?: string = '';
  document: any;

  constructor(
    public tcTicketService: TcTicketService,
    private toastService: ToastService
  ) {}

  imageModalVisible = false;
  selectedImage?: string | null;

  @HostListener('document:keydown.escape')
  onEscKey() {
    if (this.imageModalVisible) {
      this.closeImageModal();
    }
  }

  downloadAttachmentTeoremaee(document) {
    if (!document.ref) {
      this.toastService.show({
        color: 'error',
        message: 'Anexo sem ref',
      });
      return;
    }

    this.tcTicketService.loadingDocuments.set(document.ref, true);
    this.tcTicketService.downloadAttachmentTeoremaee(document).subscribe(
      res => {
        this.tcTicketService.loadingDocuments.delete(document.ref);
      },
      error => {
        console.log(error);
        this.toastService.show({
          color: 'warn',
          message: 'Houve um erro ao efetuar o download do anexo. Por favor tente novamente.',
        });
        this.tcTicketService.loadingDocuments.delete(document.ref);
      }
    );
  }

  attachmentsSaved(urls) {
    if (!this.entity!.documents) {
      this.entity!.documents = [];
    }

    urls.forEach(url => {
      let ticketDocument = new TicketDocument();
      ticketDocument.link_file = url;

      this.entity!.documents!.push(ticketDocument);
    });

    this.save.emit();
  }

  closeImageModal() {
    this.imageModalVisible = false;
    this.selectedImage = null;
  }
  openImageModal(image: string) {
    this.selectedImage = image;
    this.imageModalVisible = true;
  }

  openInNewTab() {
    if (this.selectedImage) {
      window.open(this.selectedImage, '_blank');
    }
  }

  linkStartsWithBackslash(link: string): boolean {
    return link?.startsWith('\\');
  }

  isValidImageLink(link: string): boolean {
    return link.startsWith('http') && /\.(jpg|jpeg|png|gif|bmp|webp|svg)$/i.test(link);
  }
}
